module.exports = __webpack_public_path__ + "media/empty.1ad0371b.mp3";